/**
 * SAFICのドメイン
 */
export const DOMAIN_SAFIC = 'saison.ra-abas.jp'

/**
 * SJのドメイン
 */
export const DOMAIN_SJ = 'sompo-japan.ra-abas.jp'

export default {
  SAFIC: DOMAIN_SAFIC,
  SJ: DOMAIN_SJ,
}
